import React from 'react'
import styled from 'styled-components'
import { Loader, Icon } from 'rsuite'
import Lottie from '../components/Lottie'

export default function CongressDisplay ({ loading, error, description }) {
  if (loading) {
    return (
      <LoadingContainer>
        <Loader size="lg" speed="slow"/>
      </LoadingContainer>
    )
  }

  if (error) {
    return (
      <ErrorContainer>
        <Lottie width={300} height={300} animation="notFound2" autoPlay loop/>
        <h5>{error}</h5>
        {description ? <p>{description}</p> : null}
      </ErrorContainer>
    )
  }

  return null
}

const LoadingContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  background: #FFF;
  justify-content: center;
  flex-direction: column;
`


const ErrorContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  background: #FFF;
  flex-direction: column;
  padding: 33px 20px;
  
  h5 {
    font-size: 20px;
    text-transform: uppercase;
    max-width: 300px;
    text-align: center;
  }
  
  p {
    font-size: 18px;
    font-weight: 300;
    margin-top: 24px;
    max-width: 600px;
    text-align: center;
    line-height: 30px;
  }
`
